import React, { Component } from 'react';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { Query } from 'react-apollo';
import DataComponent from './DataComponent';
import { Loading } from '../../../../../components/Loading';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import { withAccount } from '../../../../../components/AccountContext';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { matchShape, growlShape } from '../../../../../components/prop-types';


export const SURVEY_PROJECT_DETAIL_QUERY = gql`
  query surveyProjectDetailQuery($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      surveyProject(id: $id) {
        id
        name
        createdOn
        updatedOn
        createdBy {
          id
          firstName
          lastName
        }
        surveyTemplate {
          id
          title
        }
        surveys {
          edges {
            node {
              id
              self {
                ...surveyRespondent
              }
              managers {
                ...surveyRespondent
              }
              peers {
                ...surveyRespondent
              }
              directReports {
                ...surveyRespondent
              }
              others {
                ...surveyRespondent
              }              
            }
          }
        }
      }
    }
  }
  fragment surveyRespondent on SurveyRespondent {
    respondent {
      id
      firstName
      lastName
      email
    }
    startUrl
    previewInviteUrl
    previewReminderUrl
    id
    status
  }
`;

class DataContainer extends Component {
  render() {
    const { match, growl } = this.props;
    const { surveyProjectId, aid } = match.params;
    const variables = {
      accountId: aid,
      id: surveyProjectId,
    };

    return (
      <Query query={SURVEY_PROJECT_DETAIL_QUERY} variables={variables}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loading />;
          }
          if (error) {
            growlErrors(growl, error);
          }
          const { account: { surveyProject } } = data;
          return (
            <DataComponent
              surveyProject={surveyProject}
            />
          );
        }}
      </Query>
    );
  }
}

DataContainer.propTypes = {
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  withAccount(
    injectIntl(
      DataContainer,
    ),
  ),
);
